module.exports = __webpack_public_path__ + "img/banner.7606a72d.png";